import { ResourceType } from "../../../../../../../services/cloudchipr.api";

export const tagFilterKeysFixedCacheKeyGenerator = (
  resourceType: ResourceType,
) => {
  return `tag_filter_keys_${resourceType}`;
};
